import * as React from 'react'
import { BaseTextField } from '@user/components/Formik'
import { Field, Form, useFormikContext } from 'formik'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import { MultiSelect } from '@workwave-tidal/core/components'
import type { AssigneeOption, ISalesTeam } from '@user/store/salesTeam'
import {
  useBacksideData,
  useBacksideHandlers,
  useOnBacksideMount,
} from '../../hooks'
import { SalesTeamMultiselect } from '@user/components/SalesTeam/SalesTeamMultiselect/SalesTeamMultiselect'

type Props = {
  assigneeIds: string[]
  salesTeams: ISalesTeam[]
  initData: { salesTeamIds: number[]; assigneeIds: string[] }
}

export function FormFields(props: Props) {
  const { errors, touched, owners, assigneeIdsValue } = useBacksideData()
  const { submitForm } = useFormikContext()
  const { renderSummary, handleSelectOwnerId, isOptionEqual, getId } =
    useBacksideHandlers()

  useOnBacksideMount({ ...props })

  return (
    <Form autoComplete="off">
      <Box paddingBottom={2}>
        <Field
          name="numDays"
          as={TextField}
          component={BaseTextField}
          error={errors.numDays && touched.numDays}
          fullWidth
          data-test-id="upcoming-follow-ups-num-days-input"
          helperText={errors.numDays && touched.numDays ? errors.numDays : ''}
          label="Number of Days *"
          type="number"
          variant="outlined"
        ></Field>
      </Box>

      <Box paddingBottom={2} position="relative">
        <SalesTeamMultiselect
          leaveOwners
          testIdPrefix="upcoming-follow-ups-sales-team-multiselect"
        />
      </Box>

      <Box paddingBottom={2} position="relative">
        <MultiSelect<AssigneeOption>
          items={owners}
          label="Sales Team Member"
          optionMode="normal"
          inputMode="summary"
          density="normal"
          hideCheckbox={false}
          textFieldProps={{
            //@ts-expect-error pendo requires data-test-id to be on the root element of the component
            ['data-test-id']: `upcoming-follow-ups-assignee-multiselect`,
          }}
          value={assigneeIdsValue}
          getLabel={(option) => option.name}
          onChange={handleSelectOwnerId}
          getId={getId}
          autocompleteProps={{
            isOptionEqualToValue: isOptionEqual,
            size: 'small',
          }}
          renderSummary={(options) =>
            renderSummary(options, 'Sales Team Members')
          }
          placeholder="Search more Sales Team Members"
        />
      </Box>

      <Box display="flex" justifyContent="flex-end">
        <Button
          onClick={submitForm}
          color="primary"
          variant="contained"
          data-test-id="upcoming-follow-ups-save-settings-button"
        >
          Save Settings
        </Button>
      </Box>
    </Form>
  )
}
